import {DiagramSyncModeType} from '@/components/toolbar/enums';
import {CursorDiagramState} from '@/logic/cursorDiagramState';
import {VuexModule, Mutation, Action} from 'vuex-module-decorators';

/*
    Динамический модуль хранилища vuex для работы с состояниями диаграмм
*/

export class DiagramModule extends VuexModule {
  /* Возможность синхронизации */
  canSync = false;

  /* Состояние для диаграмм сигналов */
  syncedState: CursorDiagramState | null = null;

  /* Общий список диаграмм для синхронизации */
  diagrams: {id: string}[] = [];

  /* Список синхронизируемых диаграмм */
  syncDiagrams: {id: string}[] = [];

  /* Список синхронизируемых режимов */
  syncModes: {id: number; type: DiagramSyncModeType}[] = [];

  /* Показатель синхронизации*/
  get sync() {
    return {
      syncModes: this.syncModes,
      syncDiagrams: this.syncDiagrams,
      syncedState: this.syncedState,
    };
  }

  /*
    Мутация на изменение состояния
  */
  @Mutation
  syncMutation(syncedState: CursorDiagramState) {
    this.syncedState = syncedState;
  }

  /*
    Мутация на установку значения возможности синхронизации
  */
  @Mutation
  setCanSyncMutation(params: {diagrams: {id: string}[]; syncDiagrams?: {id: string}[]}) {
    this.diagrams = this.diagrams.concat(params.diagrams);

    if (params.syncDiagrams) this.syncDiagrams = params.syncDiagrams;
    if (params.diagrams.length) this.canSync = true;
  }

  /*
    Мутация на изменение параметров синхронизации
 */
  @Mutation
  setSyncSettingsMutation(params: {
    syncDiagrams: {id: string}[];
    syncModes: {id: number; type: DiagramSyncModeType}[];
    syncedState: CursorDiagramState;
  }) {
    //TODO: может быть лучше копировать
    this.syncDiagrams = params.syncDiagrams;
    this.syncModes = params.syncModes;
    this.syncedState = params.syncedState;
  }

  /*
    Мутация на сброс всего модуля
  */
  @Mutation
  clearMutation() {
    this.syncedState = null;
    this.canSync = false;
    this.diagrams = [];
    this.syncDiagrams = [];
  }

  /*
    Действие на изменение состояния
  */
  @Action
  diagramSync(state: CursorDiagramState) {
    this.context.commit('syncMutation', state);
  }

  /*
    Действия на установку возможности синхронизации
  */
  @Action
  setCanSync(params: {diagrams: {id: string}[]; syncDiagrams?: {id: string}[]}) {
    this.context.commit('setCanSyncMutation', params);
  }

  /*
    Действия при обновлении параметров синхронизации
  */
  @Action
  setSyncSettings(params: {
    syncDiagrams: {id: string}[];
    syncModes: {id: number; type: DiagramSyncModeType}[];
    syncedState: CursorDiagramState;
  }) {
    this.context.commit('setSyncSettingsMutation', params);
  }

  /*
    Действия на сброс всего модуля
  */
  @Action
  clear() {
    this.context.commit('clearMutation');
  }
}
